<template>
  <div>
    <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>中文官网</el-breadcrumb-item>
        <el-breadcrumb-item>内容管理</el-breadcrumb-item>
        <el-breadcrumb-item>游戏管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="operating">
      <span> <el-button type="primary" size="small" @click="addDialog()" >新增游戏</el-button></span>
    </div>
    <div >
      <template>
        <el-table
          :data="tableData"
          stripe
          center
          border
          highlight-current-row
          style="width: 100%">
          <el-table-column
            align="center"
            label="排序"
            width="80">
            <template slot-scope="scope">
              <el-input  size="small" v-model="scope.row.sort" @change="changeSort(scope.row)" :min="0" :max="1000" label="描述文字"></el-input>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="name"
            label="游戏名称">
          </el-table-column>
          <el-table-column
            align="center"
            label="游戏图标">
            <template slot-scope="scope">
              <el-image :src="scope.row.icon_img" alt="" style="height: 40px; width: 40px">
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="上架状态">
            <template slot-scope="scope">
              <el-tooltip :content="scope.row.is_shelves?'上架':'下架'" placement="top">
                <el-switch
                  v-model="scope.row.is_shelves"
                  @change="handleChangeStatus(scope.row, 'shelves_status','is_shelves')"
                  active-color="#13ce66"
                  inactive-color="#DCDFE6">
                </el-switch>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="编辑内容"
            width="240">
            <template slot-scope="scope" >
              <el-button
                type="primary"
                size="small"
                @click="editDialog(scope.row)">信息</el-button>
              <el-button
                type="primary" size="small"  @click="imgDialog(scope.row)">图片</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="block page-box">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page=page
            :page-sizes="[50, 100, 200, 500]"
            :page-size=page_size
            layout="total, sizes, prev, pager, next, jumper"
            :total=total>
          </el-pagination>
        </div>
      </template>
    </div>
    <el-dialog :title="dialogTitle" :visible.sync="dialogInfoVisible" :close-on-click-modal="false"  width="900px" class="padding_10">
      <el-form :model="addForm" label-width="80px" :rules="infoRules" ref="addForm">
        <el-form-item label="游戏名称" prop="name" >
          <el-input v-model="addForm.name" auto-complete="off" placeholder="请输入游戏名称"></el-input>
        </el-form-item>
        <el-form-item label="游戏标语" prop="slogan" >
          <el-input v-model="addForm.slogan" auto-complete="off" placeholder="请输入游戏标语"></el-input>
        </el-form-item>
        <el-form-item label="发行地区" prop="dis_area" >
          <el-input v-model="addForm.dis_area" auto-complete="off" placeholder="请输入发行地区"></el-input>
        </el-form-item>
        <el-form-item label="语言" prop="language" >
          <el-input v-model="addForm.language" auto-complete="off" placeholder="请输入语言"></el-input>
        </el-form-item>
        <el-form-item label="游戏介绍" prop="introduction" >
          <template>
            <Editor style="text-align: justify!important;" v-model="addForm.introduction" :isClear="isClear" @content="setAddContent"></Editor>
          </template>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" :loading="addLoading" @click="addGame('addForm')">保 存</el-button>
        <el-button  size="small" @click="callOf('addForm')">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="dialogTitle" :visible.sync="dialogEditInfoVisible" :close-on-click-modal="false"  width="900px" class="padding_10">
      <el-form :model="editForm" label-width="80px" :rules="infoRules" ref="editForm">
        <el-form-item label="游戏名称" prop="name" >
          <el-input v-model="editForm.name" auto-complete="off" placeholder="请输入游戏名称"></el-input>
        </el-form-item>
        <el-form-item label="游戏标语" prop="slogan" >
          <el-input v-model="editForm.slogan" auto-complete="off" placeholder="请输入游戏标语"></el-input>
        </el-form-item>
        <el-form-item label="发行地区" prop="dis_area" >
          <el-input v-model="editForm.dis_area" auto-complete="off" placeholder="请输入发行地区"></el-input>
        </el-form-item>
        <el-form-item label="语言" prop="language" >
          <el-input v-model="editForm.language" auto-complete="off" placeholder="请输入语言"></el-input>
        </el-form-item>
        <el-form-item label="游戏介绍" prop="introduction" >
          <template>
            <Editor style="text-align: justify!important;" v-model="editForm.introduction" :isClear="isClear" @content="setEditContent"></Editor>
          </template>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary"  size="small" :loading="infoLoading" @click="editInfo('editForm')">保 存</el-button>
        <el-button size="small" @click="callOf('editForm')">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="dialogTitle" :visible.sync="dialogImgVisible" :close-on-click-modal="false"  width="800px" class="padding_10">
      <el-row :gutter="24">
        <el-col :span="8" class="col-center">
          <span><span style="color: red">*</span>游戏图标<span style="color: red;margin-left: 10px">100*100</span></span>
          <div style="margin-top: 10px">
            <el-upload
              action="#"
              list-type="picture-card"
              :before-upload="beforeAvatarUpload"
              :on-change="handleIconChange"
              :http-request="submitUpload"
              :auto-upload="true"
              accept=".jpg,.png,.jpeg"
              :show-file-list="false"
              ref="icon">
              <img  v-if="imgInfo.icon_img" :src="imgInfo.icon_img"   style="width: 146px!important;height: 146px;">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
        </el-col>
        <el-col :span="8" class="col-center">
          <span><span style="color: red">*</span>游戏中心宣传图<span style="color: red;margin-left: 10px">376*223</span></span>
          <div style="margin-top: 10px;">
            <el-upload
              action="#"
              list-type="picture-card"
              :before-upload="beforeAvatarUpload"
              :on-change="handleCenterChange"
              :http-request="submitUpload"
              :auto-upload="true"
              accept=".jpg,.png,.jpeg"
              :show-file-list="false"
              ref="center">
              <img v-if="imgInfo.center_img" :src="imgInfo.center_img"  style="width: 146px!important;height: 146px;">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
        </el-col>
        <el-col :span="8" class="col-center">
          <span><span style="color: red">*</span>移动端游戏中心图<span style="color: red;margin-left: 10px">252*252</span></span>
          <div style="margin-top: 10px;">
            <el-upload
              action="#"
              list-type="picture-card"
              :before-upload="beforeAvatarUpload"
              :on-change="handleMobileCenterChange"
              :http-request="submitUpload"
              :auto-upload="true"
              accept=".jpg,.png,.jpeg"
              :show-file-list="false"
              ref="mobile_center">
              <img v-if="imgInfo.mobile_center_img" :src="imgInfo.mobile_center_img"  style="width: 146px!important;height: 146px;">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="8" class="col-center">
          <span>游戏奖项图<span style="color: red;margin-left: 10px">264*68</span></span>
          <div style="margin-top: 10px">
            <el-upload
              action="#"
              list-type="picture-card"
              :before-upload="beforeAvatarUpload"
              :on-change="handleAwardsChange"
              :http-request="submitUpload"
              :auto-upload="true"
              accept=".jpg,.png,.jpeg"
              :show-file-list="false"
              ref="awards">
              <img  v-if="imgInfo.awards_img" :src="imgInfo.awards_img"   style="width: 146px!important;height: 146px;">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
        </el-col>
        <el-col :span="8" class="col-center">
          <span><span style="color: red">*</span>游戏详情底图<span style="color: red;margin-left: 10px">1920*308</span></span>
          <div style="margin-top: 10px;">
            <el-upload
              action="#"
              list-type="picture-card"
              :before-upload="beforeAvatarUpload"
              :on-change="handleDetailsChange"
              :http-request="submitUpload"
              :auto-upload="true"
              accept=".jpg,.png,.jpeg"
              :show-file-list="false"
              ref="center">
              <img v-if="imgInfo.details_img" :src="imgInfo.details_img"  style="width: 146px!important;height: 146px;">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
        </el-col>
        <el-col :span="8" class="col-center">
          <span><span style="color: red">*</span>移动端背景图<span style="color: red;margin-left: 10px">750*466</span></span>
          <div style="margin-top: 10px;">
            <el-upload
              action="#"
              list-type="picture-card"
              :before-upload="beforeAvatarUpload"
              :on-change="handleMobileBackgroundChange"
              :http-request="submitUpload"
              :auto-upload="true"
              accept=".jpg,.png,.jpeg"
              :show-file-list="false"
              ref="mobile_background">
              <img v-if="imgInfo.mobile_background_img" :src="imgInfo.mobile_background_img"  style="width: 146px!important;height: 146px;">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
        </el-col>
      </el-row>
      <div style="margin: 20px 0">
        <el-upload
          action="#"
          :auto-upload="false"
          :before-upload="beforeAvatarUpload"
          :on-change="handleSnapshotChange"
          name="file[]"
          accept=".jpg,.png,.jpeg"
          :show-file-list="false"
          ref="snapshot"
          multiple
           style="display: inline-block"
        >
          <el-button size="small" type="primary">选择文件</el-button>
        </el-upload>
        <el-button style="margin-left: 10px;" size="small" type="success"  @click="multipleUpload">上传文件</el-button>
        <div slot="tip" class="el-upload__tip" style="color: red">选择文件后请点击上传按钮，上传图片</div>
        <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过2MB<span style="color: red;margin-left: 10px">1280*720</span></div>
      </div>
      <div class="img-list">
        <div :gutter="24" v-for="img in imgInfo.snapshot_img" v-dragging="{ item: img, list: imgInfo.snapshot_img, group: 'img' }" :key="img.id" class="img-item">
          <el-image :src="img.file_path"  :preview-src-list="srcList" class="img-w-h" >
            <div slot="error" class="image-slot">
              <i class="el-icon-picture-outline"></i>
            </div>
          </el-image>
          <i class="el-icon-error img-l-close" @click="delImg(img)" style=""></i>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="small"  :loading="imgLoading" @click="setImg()">保 存</el-button>
        <el-button size="small" @click="callOf('')">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {getList, changeStatus, addGame, storeSort, getInfo, editInfo, getImgInfo, setGameImg} from '../../api/game'
import {uploadImg, multipleUploadImg} from '../../api'
import Editor from '../../components/Editor'
export default {
  data () {
    return {
      imgLoading: false,
      addLoading: false,
      infoLoading: false,
      dialogInfoVisible: false,
      dialogEditInfoVisible: false,
      dialogImgVisible: false,
      isClear: false,
      tableData: [],
      imgForm: {
        id: 0,
        icon_file_id: '',
        center_file_id: '',
        mobile_center_file_id: '',
        awards_file_id: '',
        details_file_id: '',
        snapshot_file_id: '',
        mobile_background_file_id: ''
      },
      iconFile: {},
      centerFile: {},
      mobileCenterFile: {},
      awardsFile: {},
      detailsFile: {},
      mobileBackgroundFile: {},
      snapshotFile: [],
      imgInfo: {
        id: 0,
        icon_img: '',
        center_img: '',
        mobile_center_img: '',
        awards_img: '',
        details_img: '',
        mobile_background_img: '',
        snapshot_img: []
      },
      dialogTitle: '',
      addForm: {
        name: '',
        slogan: '',
        dis_area: '',
        language: '',
        introduction: ''
      },
      editForm: {
        id: 0,
        name: '',
        slogan: '',
        dis_area: '',
        language: '',
        introduction: ''
      },
      page: 1,
      page_size: 50,
      total: 0,
      curr_click_upload_tag: '',
      srcList: [],
      infoRules: {
        name: [
          { required: true, message: '请输入游戏名称', trigger: 'blur' }
        ],
        introduction: [
          { required: true, message: '请输入游戏介绍', trigger: 'blur' }
        ]
      }
    }
  },
  components: { Editor },
  mounted () {
    // 页面数据初始化表格数据
    this.setTableData()
  },
  methods: {
    // 添加富文本回调赋值
    setAddContent (value) {
      this.addForm.introduction = value
    },
    // 编辑富文本回调赋值
    setEditContent (value) {
      this.editForm.introduction = value
    },
    // 表格填充
    setTableData () {
      getList({
        page: this.page,
        page_size: this.page_size,
        type_ids: this.type_ids
      }).then(res => {
        let {status, message} = res
        if (status === 2000) {
          this.tableData = res.data.table_list
          this.total = res.data.total
        } else {
          this.$notify({
            message: message,
            type: 'warning',
            offset: 100,
            showClose: false
          })
        }
      })
    },
    // 关闭弹窗
    callOf (formName) {
      if (formName === 'addForm') {
        this.dialogInfoVisible = false
      } else if (formName === 'editForm') {
        this.dialogEditInfoVisible = false
      } else {
        this.dialogImgVisible = false
        this.imgResetFields()
      }
      if (formName) {
        this.$refs[formName].resetFields()
      }
    },
    // 清空图片表单对象字段
    imgResetFields () {
      this.imgForm = {
        id: 0,
        icon_file_id: '',
        center_file_id: '',
        awards_file_id: '',
        details_file_id: ''
      }
      this.imgInfo = {
        id: 0,
        icon_img: '',
        center_img: '',
        awards_img: '',
        details_img: ''
      }
    },
    // 打开添加弹窗
    addDialog () {
      this.dialogInfoVisible = true
      this.dialogTitle = '添加游戏'
    },
    // 打开编辑弹窗
    editDialog (row) {
      this.dialogEditInfoVisible = true
      this.dialogTitle = '编辑游戏'
      // 获取游戏数据
      getInfo({
        id: row.id
      }).then(res => {
        let {status, message} = res
        if (status === 2000) {
          this.editForm = res.data
          this.editForm.id = row.id
        } else {
          this.$notify({
            message: message,
            type: 'warning',
            offset: 100,
            showClose: false
          })
        }
      })
    },
    // 修改游戏信息
    editInfo (formName) {
      this.infoLoading = true
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const storeData = this.editForm
          editInfo(storeData).then(res => {
            let {status, message} = res
            if (status === 2000) {
              this.$notify({
                message: message,
                type: 'success',
                offset: 100,
                showClose: false
              })
              this.setTableData()
              this.dialogEditInfoVisible = false
              this.$refs[formName].resetFields()
            } else {
              this.$notify({
                message: message,
                type: 'warning',
                offset: 100,
                showClose: false
              })
            }
          })
        }
      })
      setTimeout(() => {
        this.infoLoading = false
      }, 500)
    },
    // 分页大小切换回调
    handleSizeChange (val) {
      this.page_size = val
      this.setTableData()
    },
    // 页码切换回调
    handleCurrentChange (val) {
      this.page = val
      this.setTableData()
    },
    // 状态切换
    handleChangeStatus (row, column, rowColumn) {
      changeStatus({
        id: row.id,
        column: column,
        status: row[rowColumn]
      }).then(res => {
        let {status, message} = res
        if (status === 2000) {
          this.$notify({
            message: message,
            type: 'success',
            offset: 100,
            showClose: false
          })
        } else {
          this.$notify({
            message: message,
            type: 'warning',
            offset: 100,
            showClose: false
          })
        }
        this.setTableData()
      })
    },
    // 添加游戏
    addGame (formName) {
      this.addLoading = true
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const storeData = this.addForm
          addGame(storeData).then(res => {
            let { status, message } = res
            if (status === 2000) {
              this.$notify({
                message: message,
                type: 'success',
                offset: 100,
                showClose: false
              })
              this.setTableData()
              this.dialogInfoVisible = false
              this.$refs[formName].resetFields()
            } else {
              this.$notify({
                message: message,
                type: 'warning',
                offset: 100,
                showClose: false
              })
            }
          })
        }
      })
      setTimeout(() => {
        this.addLoading = false
      }, 500)
    },
    // 更改排序
    changeSort (row) {
      storeSort({
        id: row.id,
        sort: row.sort
      }).then(res => {
        let {status, message} = res
        if (status === 2000) {
          this.$notify({
            message: message,
            type: 'success',
            offset: 100,
            showClose: false
          })
          this.setTableData()
        } else {
          this.$notify({
            message: message,
            type: 'warning',
            offset: 100,
            showClose: false
          })
          this.setTableData()
        }
      })
    },
    // 图片上传弹窗
    imgDialog (row) {
      this.dialogImgVisible = true
      this.dialogTitle = '游戏图片'
      getImgInfo({id: row.id}).then(res => {
        let {status, message} = res
        if (status === 2000) {
          this.imgForm = {
            id: row.id,
            icon_file_id: res.data.icon_file_id,
            center_file_id: res.data.center_file_id,
            mobile_center_file_id: res.data.mobile_center_file_id,
            awards_file_id: res.data.awards_file_id ? res.data.awards_file_id : '',
            details_file_id: res.data.details_file_id,
            mobile_background_file_id: res.data.mobile_background_file_id,
            snapshot_file_id: res.data.snapshot_img ? res.data.snapshot_img.map(item => { return item.id }) : res.data.snapshot_img
          }
          this.imgInfo = {
            id: row.id,
            icon_img: res.data.icon_img,
            center_img: res.data.center_img,
            mobile_center_img: res.data.mobile_center_img,
            awards_img: res.data.awards_img,
            details_img: res.data.details_img,
            mobile_background_img: res.data.mobile_background_img,
            snapshot_img: res.data.snapshot_img
          }
          this.srcList = res.data.snapshot_img ? res.data.snapshot_img.map(item => { return item.file_path }) : res.data.snapshot_img
        } else {
          this.$notify({
            message: message,
            type: 'warning',
            offset: 100,
            showClose: false
          })
        }
      })
    },
    // 上传前回调
    beforeAvatarUpload (file) {
      const isImg = ['image/jpeg', 'image/png', 'image/jpg'].indexOf(file.type) >= 0
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isImg) {
        this.$notify({
          message: '上传图片必须为jpg或png 格式!',
          type: 'warning',
          offset: 100,
          showClose: false
        })
      }
      if (!isLt2M) {
        this.$notify({
          message: '上传图片大小不能超过 2MB!',
          type: 'warning',
          offset: 100,
          showClose: false
        })
      }
      return isImg && isLt2M
    },
    // 上传icon文件，获取文件流
    handleIconChange (file) {
      this.iconFile = file.raw
      this.curr_click_upload_tag = 'icon'
    },
    // 上传center文件，获取文件流
    handleCenterChange (file) {
      this.centerFile = file.raw
      this.curr_click_upload_tag = 'center'
    },
    // 上传移动端center文件，获取文件流
    handleMobileCenterChange (file) {
      this.mobileCenterFile = file.raw
      this.curr_click_upload_tag = 'mobile_center'
    },
    // 上传awards文件，获取文件流
    handleAwardsChange (file) {
      this.awardsFile = file.raw
      this.curr_click_upload_tag = 'awards'
    },
    // 上传icon文件，获取文件流
    handleDetailsChange (file) {
      this.detailsFile = file.raw
      this.curr_click_upload_tag = 'details'
    },
    // 上传游戏背景图文件，获取文件流
    handleMobileBackgroundChange (file) {
      this.mobileBackgroundFile = file.raw
      this.curr_click_upload_tag = 'mobile_background'
    },
    // 上传snapshot文件，获取文件流
    handleSnapshotChange (file) {
      this.snapshotFile.push(file.raw)
      this.curr_click_upload_tag = 'snapshot'
      this.$refs['snapshot'].clearFiles()
    },
    // 图片上传
    submitUpload () {
      // 创建表单对象
      let position = this.curr_click_upload_tag
      let form = new FormData()
      // 后端接受参数 ，可以接受多个参数
      let file = ''
      switch (position) {
        case 'icon':
          file = this.iconFile
          break
        case 'center':
          file = this.centerFile
          break
        case 'mobile_center':
          file = this.mobileCenterFile
          break
        case 'awards':
          file = this.awardsFile
          break
        case 'details':
          file = this.detailsFile
          break
        case 'mobile_background':
          file = this.mobileBackgroundFile
          break
        default:
          file = ''
          break
      }
      form.append('file', file)
      uploadImg(form).then(res => {
        let {status, message} = res
        if (status === 2000) {
          switch (position) {
            case 'icon':
              this.imgForm.icon_file_id = res.data.file_id
              this.imgInfo.icon_img = res.data.file_path
              break
            case 'center':
              this.imgForm.center_file_id = res.data.file_id
              this.imgInfo.center_img = res.data.file_path
              break
            case 'mobile_center':
              this.imgForm.mobile_center_file_id = res.data.file_id
              this.imgInfo.mobile_center_img = res.data.file_path
              break
            case 'awards':
              this.imgForm.awards_file_id = res.data.file_id
              this.imgInfo.awards_img = res.data.file_path
              break
            case 'details':
              this.imgForm.details_file_id = res.data.file_id
              this.imgInfo.details_img = res.data.file_path
              break
            case 'mobile_background':
              this.imgForm.mobile_background_file_id = res.data.file_id
              this.imgInfo.mobile_background_img = res.data.file_path
              break
            default:
              break
          }
          this.$notify({
            message: message,
            type: 'success',
            offset: 100,
            showClose: false
          })
        } else {
          this.$notify({
            message: message,
            type: 'warning',
            offset: 100,
            showClose: false
          })
        }
        this.$refs[position].clearFiles()
      })
    },
    // 图片批量上传
    multipleUpload () {
      let form = new FormData()
      this.snapshotFile.forEach((item, index) => {
        form.append('file[]', item)
      })
      multipleUploadImg(form).then(res => {
        let {status, message} = res
        if (status === 2000) {
          res.data.forEach((item, index) => {
            this.srcList.push(item.file_path)
            this.imgInfo.snapshot_img.push({id: item.file_id, file_path: item.file_path})
            this.imgForm.snapshot_file_id.push(item.file_id)
          })
          this.snapshotFile = []
          this.$notify({
            message: message,
            type: 'success',
            offset: 100,
            showClose: false
          })
        } else {
          this.$notify({
            message: message,
            type: 'warning',
            offset: 100,
            showClose: false
          })
        }
        this.$refs['snapshot'].clearFiles()
      })
    },
    // 设置游戏图片
    setImg () {
      this.imgLoading = true
      this.imgForm.snapshot_file_id = this.imgInfo.snapshot_img.map(item => { return item.id })
      setGameImg(this.imgForm).then(res => {
        let {status, message} = res
        if (status === 2000) {
          this.dialogImgVisible = false
          this.setTableData()
          this.imgResetFields()
          this.$notify({
            message: message,
            type: 'success',
            offset: 100,
            showClose: false
          })
        } else {
          this.$notify({
            message: message,
            type: 'warning',
            offset: 100,
            showClose: false
          })
        }
      })
      setTimeout(() => {
        this.imgLoading = false
      }, 500)
    },
    // 删除快照
    delImg (img) {
      this.imgInfo.snapshot_img.forEach((item, index) => {
        if (item.id === img.id) {
          this.imgInfo.snapshot_img.splice(index, 1)
        }
      })
    }
  }
}
</script>
<style>
.col-center {
  text-align: center!important;
  margin-bottom: 10px!important;
}
.img-list{
  height: 120px;
  line-height: 120px;
  width: 750px;
  padding: 6px 6px;
  border: 1px solid #cccccc;
  white-space: nowrap;
  overflow-y: hidden;
  overflow-x: auto;
}
.img-item{
  display: inline-block;
  margin-right: 10px;
  position: relative;
}
.img-w-h{
  height: 100px!important;
  width: 170px!important;
}
.img-l-close{
  position: absolute;
  top: -4px;
  right: -4px;
  font-size: 20px;
  color: #f2d401;
}
.img-l-close:hover{
  cursor:pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/game/index.vue